import React from 'react';
import PlainCRUD, { defaultFields } from 'components/PlainCRUD';
import {
  deleteCanalDePago, getCanalesDePago, patchCanalDePago, postCanalDePago,
} from 'api/configuracion/canalDePago';
import { getCatalogoDeCanalesDePago, getTiposDePagos } from 'api/configuracion';

// eslint-disable-next-line react/prop-types
const CanalDePago = ({ permission }) => (
  <PlainCRUD
    title="Canal De Pago"
    permission={permission}
    get={getCanalesDePago}
    post={postCanalDePago}
    patch={patchCanalDePago}
    delete={deleteCanalDePago}
    fields={[
      defaultFields.clave,
      {
        name: 'catalogo_de_canal_de_pago',
        label: 'Catálogo de Canal de pago',
        type: 'select',
        render: (item) => item?.descripcion,
        required: true,
      },
      defaultFields.descripcion,
      {
        name: 'tipo_de_pago',
        label: 'Tipo de Pago',
        render: (item) => item?.descripcion,
        type: 'select',
        required: true,
      },
    ]}
    catalogs={[
      {
        permission: 'catalogodecanalesdepago',
        get: getCatalogoDeCanalesDePago,
        formItemName: 'catalogo_de_canal_de_pago',
      },
      {
        permission: 'tipodepago',
        get: getTiposDePagos,
        formItemName: 'tipo_de_pago',
      },
    ]}
  />
);

export default CanalDePago;
